import { createAction, props } from "@ngrx/store";
import { OptionModel } from "../grid/filters/option.model";

export enum JobFulfillmentTypeEnum {
    LoadJobFulfillmentType = '[GRID OPTION JOB FULFILLMENT TYPE FILTER COMPONENT] Load Job Fulfillment Type',
    LoadJobFulfillmentTypeSuccess = '[GRID OPTION JOB FULFILLMENT TYPE FILTER COMPONENT] Load Job Fulfillment Type Success',
    LoadJobFulfillmentTypeFailure = '[GRID OPTION JOB FULFILLMENT TYPE FILTER COMPONENT] Load Job Fulfillment Type Failure',
}

export const loadJobFulfillmentType = createAction(JobFulfillmentTypeEnum.LoadJobFulfillmentType);

export const loadJobFulfillmentTypeSuccess = createAction(
    JobFulfillmentTypeEnum.LoadJobFulfillmentTypeSuccess,
    props<{ jobFulfillmentTypes: OptionModel[] }>()
);

export const loadJobFulfillmentTypeFailure = createAction(
    JobFulfillmentTypeEnum.LoadJobFulfillmentTypeFailure,
    props<{ error: unknown }>()
);
